// extracted by mini-css-extract-plugin
export default {"containerPaymentType":"paymentType_containerPaymentType__5TdUw","labelpaymentType":"paymentType_labelpaymentType__LxiHp"};